import { getApprove, getPermissionActiveMenu, getPermissionMenus } from './app.utils'

const permissionMenus = () => {
    return getPermissionActiveMenu() || {}
}
const ap = getApprove()

/**
 * ทุกฟิลด์เป็น getter โดยตั้งใจ — ห้ามเปลี่ยนกลับไปคำนวณค่าตอนสร้าง object
 *
 * หน้าจำนวนมาก (~33 หน้า) เรียก `const permissions = { isCreate: isCreate(), ... }` ไว้ที่ module scope
 * ซึ่งทำงานตอน import ไฟล์ และ router.ts import ทุกหน้าแบบ eager (ไม่มี React.lazy)
 * โค้ดบรรทัดนั้นจึงทำงานครั้งเดียวตอนโหลด bundle ก่อน React จะ render อะไรเลย
 *
 * สมัยที่เปลี่ยนหน้าด้วย full reload ทุกครั้ง ค่าที่ freeze ไว้ยังถูก เพราะ sidebar เขียน activeMenu
 * ลง localStorage ก่อน reload พอเปลี่ยนมาเป็น SPA (AppShell) bundle ไม่ถูกโหลดใหม่อีก
 * ค่าที่ freeze จึงค้างเป็นสิทธิ์ของหน้าที่เปิดตอนโหลดเว็บ — ปุ่มจางจนกว่าผู้ใช้จะกด F5
 *
 * ทำเป็น getter แล้วค่าจะถูกอ่านตอนที่หน้าเรียกใช้ (ตอน render) ซึ่ง AppShell กั้นไว้แล้วว่า
 * ต้องเขียน activeMenu ของ path ปัจจุบันเสร็จก่อน — ได้ค่าถูกทั้งตอน SPA navigate และตอน reload
 * รูปร่างที่คืน (style / val / disabled) เหมือนเดิมทุกตัว ฝั่งที่เรียกใช้ไม่ต้องแก้
 */
export const isCreate = () => ({
    get style() {
        return permissionMenus()?.isCreate === 1 ? 'create' : 'disable'
    },
    get val() {
        const permission: any = permissionMenus()
        return permission?.isCreate ? permission.isCreate : 0
    },
    get disabled() {
        return permissionMenus()?.isCreate ? false : true
    },
})

export const isDelete = () => ({
    get style() {
        return permissionMenus()?.isDelete === 1 ? 'delete' : 'disable'
    },
    get val() {
        const permission: any = permissionMenus()
        return permission?.isDelete ? permission.isDelete : 0
    },
    get disabled() {
        return permissionMenus()?.isDelete ? false : true
    },
})

export const isUpdate = () => ({
    get style() {
        return permissionMenus()?.isUpdate === 1 ? 'update' : 'disable'
    },
    get val() {
        const permission: any = permissionMenus()
        return permission?.isUpdate ? permission.isUpdate : 0
    },
    get disabled() {
        return permissionMenus()?.isUpdate ? false : true
    },
})

export const isView = () => ({
    get style() {
        return permissionMenus()?.isView === 1 ? 'view' : 'disable'
    },
    get val() {
        const permission: any = permissionMenus()
        return permission?.isView ? permission.isView : 0
    },
    get disabled() {
        return permissionMenus()?.isView ? false : true
    },
})

export const isExport = () => ({
    get style() {
        return permissionMenus()?.isExport === 1 ? 'export' : 'disable'
    },
    /** อ่าน isView ไม่ใช่ isExport — ของเดิมเป็นแบบนี้ ไม่แก้ในรอบนี้เพราะจะเปลี่ยนพฤติกรรมหน้าที่ใช้ val อยู่ */
    get val() {
        const permission: any = permissionMenus()
        return permission?.isExport ? permission.isView : 0
    },
    get disabled() {
        return permissionMenus()?.isExport ? false : true
    },
})

export const isApporve = () => ({
    get style() {
        return permissionMenus()?.isApporve === 1 ? 'apporve' : 'disable'
    },
    /** อ่าน isView ไม่ใช่ isApporve — ของเดิมเป็นแบบนี้ ไม่แก้ในรอบนี้ด้วยเหตุผลเดียวกับ isExport */
    get val() {
        const permission: any = permissionMenus()
        return permission?.isApporve ? permission.isView : 0
    },
    get disabled() {
        // disabled: permission?.isApporve ? false : ap ? false : true
        return permissionMenus()?.isApporve ? false : true
    },
})
